module.exports = __webpack_public_path__ + "img/time-bg-red.d884760c.png";